import { useEffect, useState } from "react"
import { cloneDeep } from "lodash"

export const useObjectivesFromTechnicalSpecification = ({ data }) => {
  const [developmentObjectiveIndicators, setDevelopmentObjectiveIndicators] = useState([])
  const [generalObjectiveIndicators, setGeneralObjectiveIndicators] = useState([])
  const [specificObjectives, setSpecificObjectives] = useState(undefined)

  useEffect(() => {
    if (!data) return
    const clonedDevelopmentObjectiveIndicators = [
      ...(data?.TechnicalSpecification?.developmentObjectiveIndicators || [])
    ]
    const orderedDevelopmentObjectiveIndicators = clonedDevelopmentObjectiveIndicators
      .sort((indicatorA, indicatorB) => (indicatorA?.orderIndex || 0) - (indicatorB?.orderIndex || 0))
    const developmentIndicatorsWithOrderIndex = orderedDevelopmentObjectiveIndicators.map((indicator, index) => ({
      ...indicator,
      orderIndex: index
    }))

    setDevelopmentObjectiveIndicators(developmentIndicatorsWithOrderIndex)

    const clonedGeneralObjectiveIndicators = [
      ...(data?.TechnicalSpecification?.generalObjectiveIndicators || [])
    ]
    const orderedGeneralObjectiveIndicators = clonedGeneralObjectiveIndicators
      .sort((indicatorA, indicatorB) => (indicatorA?.orderIndex || 0) - (indicatorB?.orderIndex || 0))
    const generalIndicatorsWithOrderIndex = orderedGeneralObjectiveIndicators.map((indicator, index) => ({
      ...indicator,
      orderIndex: index
    }))

    setGeneralObjectiveIndicators(generalIndicatorsWithOrderIndex)

    let specificObjectives = [...data?.TechnicalSpecification?.specificObjectives]
    specificObjectives = specificObjectives?.sort((a, b) =>
      a.orderIndex - b.orderIndex
    ) || []

    setSpecificObjectives(specificObjectives)
  }, [data])

  const getIndicatorsByLabel = ({ specificObjectiveIndex, indicatorType }) => ({
    GENERAL: () => cloneDeep(generalObjectiveIndicators),
    DEVELOPMENT: () => cloneDeep(developmentObjectiveIndicators),
    SPECIFIC: () => cloneDeep(specificObjectives[specificObjectiveIndex][indicatorType])
      ?.sort((a, b) => a.orderIndex - b.orderIndex)
  })

  const updateIndicatorsByLabel = ({ specificObjectiveIndex, indicatorType }) => ({
    GENERAL: indicators => setGeneralObjectiveIndicators(indicators),
    DEVELOPMENT: indicators => setDevelopmentObjectiveIndicators(indicators),
    SPECIFIC: indicators => {
      const specificObjective = cloneDeep(specificObjectives[specificObjectiveIndex])
      specificObjective[indicatorType] = indicators

      setSpecificObjectives(prevSpecificObjectives =>
        updateSpecificObjectives({
          specificObjective,
          prevSpecificObjectives,
          specificObjectiveIndex
        }))
    }
  })

  const updateSpecificObjectives = ({ prevSpecificObjectives, specificObjective, specificObjectiveIndex }) => {
    const clonedPrevSpecificObjectives = cloneDeep(prevSpecificObjectives)
    clonedPrevSpecificObjectives[specificObjectiveIndex] = specificObjective
    return clonedPrevSpecificObjectives
  }


  return {
    specificObjectives,
    getIndicatorsByLabel,
    setSpecificObjectives,
    updateIndicatorsByLabel,
    generalObjectiveIndicators,
    developmentObjectiveIndicators
  }
}
